import type { FC } from "react";

import { useLocatorTranslations } from "@locators/components/shared/hooks/useLocatorTranslations";

import { formatDate } from "@jti/ui/utils/formatDate/formatDate";

import styles from "./EventDate.module.scss";

type EventDateProps = {
  startDate?: string;
  endDate?: string;
};

const getFormattedEventDate = ({ startDate, endDate }: EventDateProps) => {
  if (!startDate) {
    return "";
  }

  const formattedStartDate = formatDate(startDate);
  const formattedEndDate = endDate ? formatDate(endDate) : "";

  return formattedEndDate ? `${formattedStartDate} – ${formattedEndDate}` : formattedStartDate;
};

export const EventDate: FC<EventDateProps> = ({ startDate, endDate }) => {
  const { __ } = useLocatorTranslations();
  const formattedEventDate = getFormattedEventDate({ startDate, endDate });

  if (!formattedEventDate) {
    return null;
  }

  return (
    <div className={styles.eventDate}>
      <span className={styles.eventDateLabel}>{__("events.date_label")}</span>
      <span className={styles.eventDateValue}>{formattedEventDate}</span>
    </div>
  );
};
